import Vue from 'vue';

export const TOASTS_CREATE_SUCCESS = 'toasts/create/SUCCESS';
export const TOASTS_DESTROY_SUCCESS = 'toasts/destroy/SUCCESS';

const TOAST_SECONDS = 8;
const WORDS_PER_SECOND = 2;

export default {
  namespaced: true,
  state: {
    identifier: 0,
    items: {},
  },
  actions: {
    create({ commit, state }, payload) {
      commit(TOASTS_CREATE_SUCCESS, payload);

      const id = state.identifier;
      const seconds = Math.min(TOAST_SECONDS, payload.message.split(' ').length / WORDS_PER_SECOND);
      setTimeout(commit.bind(null, TOASTS_DESTROY_SUCCESS, id), seconds * 1000);

      return Promise.resolve();
    },
    destroy({ commit }, id) {
      commit(TOASTS_DESTROY_SUCCESS, id);

      return Promise.resolve();
    },
  },
  mutations: {
    [TOASTS_CREATE_SUCCESS](state, payload) {
      state.identifier += 1;

      Vue.set(state.items, state.identifier, {
        id: state.identifier,
        message: payload.message,
        color: payload.color,
      });
    },
    [TOASTS_DESTROY_SUCCESS](state, id) {
      Vue.delete(state.items, id);
    },
  },
};
